import * as React from "react";
import {observer} from "mobx-react";
import {Box} from "@mui/material";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import FormSection from "../../../forms/FormSection";
import useFeature from "../../../useFeature";
import {useApplication} from "../../../ApplicationProvider";
import DeliverySiteOnboardingEditScreen from "../../delivery_site_onboarding/DeliverySiteOnboardingScreen";
import AuthorizationDeliverySiteOnboardingFeature from "./AuthorizationDeliverySiteOnboardingFeature";

function AuthorizationDeliverySiteOnboardingScreen({deliverySiteOnboardingId, showFiscalProfile = false}) {
    const application = useApplication();
    const fiscalProfileFeature = useFeature(
        () => new AuthorizationDeliverySiteOnboardingFeature(application, deliverySiteOnboardingId, showFiscalProfile),
        [deliverySiteOnboardingId, showFiscalProfile]
    );

    const renderCmDocument = (title, file) => {
        const fileIsUploaded = file && file.url;
        return (
            <Box>
                <Typography style={{fontSize: "14px", fontWeight: 600}}>{title}</Typography>
                {fileIsUploaded
                    ? <Link href={file.url} target="_blank" rel="noopener" style={{fontSize: "14px"}}>{file.name || "Ver documento"}</Link>
                    : <Typography sx={{fontSize: "14px", color: "text.secondary"}}>No cargado</Typography>}
            </Box>
        );
    };

    const fiscalProfileSection = () => {
        if (!showFiscalProfile || !fiscalProfileFeature || !fiscalProfileFeature.loaded) {
            return null;
        }
        return (
            <FormSection title="Formularios CM (Perfil Fiscal del Cliente)">
                {renderCmDocument("Formulario CM01", fiscalProfileFeature.cm01Form())}
                {renderCmDocument("Formulario CM05", fiscalProfileFeature.cm05Form())}
            </FormSection>
        );
    };

    return (
        <>
            {fiscalProfileSection()}
            <DeliverySiteOnboardingEditScreen id={deliverySiteOnboardingId} readonly={true}/>
        </>
    );
}

export default observer(AuthorizationDeliverySiteOnboardingScreen);
